import React, {Component} from "react";
import {Layout, Row, Col,  Table, Space, Spin} from "antd";
import {RightCircleTwoTone} from "@ant-design/icons";

import '../css/main.less'
import "../css/aiReportView.less"
import AxiosUtil from "../../utils/AxiosUtil";
import SearchBar from "./components/SearchBar";

import "antd/lib/style/themes/dark.less"
import NavHeader from "../../components/NavHeader";
import NavFooter from "../../components/NavFooter";


interface IProps {
    match:any
}

export default class AiReportHome extends Component<IProps> {

    state = {
        loading: false,
        //symbolData: [] as SymbolProps[],
        //options: [],
        mainData: {dayList:[],weekList:[],monthList:[]},
        //exColumns: [],
        //peColumns: [],
        //yzyqData: [],
        //yzyqYear: {max: {year:""}, min: {year:""}},

        todayTotal: 0,
        todayDate:""
    }

    componentDidMount() {
        this.loadSymbolData();
        //const symbol = this.props.match.params.symbol;
        this.loadMainData();
    }

    render() {
        const columns=[
            {title: "代码",
                key: "symbol",
                dataIndex: "symbol",
                align: 'center' as 'center',
                width: 200,
                render: (text:any, record: any)=>(<a href={`/#/ai-report/reportview/${record.symbol}`}>{text}</a>)
            },
            {title: "名称",
                key: "security_name",
                dataIndex: "security_name",
                align: 'center' as 'center',
                width: 200,
                render: (text:any, record: any)=>(<a href={`/#/ai-report/reportview/${record.symbol}`}>{text}</a>)
            },
            {title: "研报数",
                key: "counts",
                dataIndex: "counts",
                align: 'center' as 'center',
                width: 200,
            },
        ];
        const columns2=[
            {title: "代码",
                key: "symbol",
                dataIndex: "symbol",
                align: 'center' as 'center',
                width: 200,
                render: (text:any, record: any)=>(<a href={`/#/ai-report/reportview/${record.symbol}`}>{text}</a>)
            },
            {title: "名称",
                key: "security_name",
                dataIndex: "security_name",
                align: 'center' as 'center',
                width: 200,
                render: (text:any, record: any)=>(<a href={`/#/ai-report/reportview/${record.symbol}`}>{text}</a>)
            },
            {title: "日期",
                key: "counts",
                dataIndex: "publish_date",
                align: 'center' as 'center',
                width: 200,
            },
        ];

        const searchCallback=(code:string)=>{
            window.location.replace('/#/ai-report/reportview/' + code)
            this.loadMainData();
        }

        console.log(this.props.match);
        return (
            <Layout className={"body"}>
                <NavHeader />
                <div className={"ai-report"} >

                    <div className={"main"}>
                        <Row className={"home-bar"}>
                            <Col span={6}>
                            </Col>
                            <Col span={12}>
                                <SearchBar searchCallback={searchCallback} ></SearchBar>
                            </Col>
                            <Col span={6}>
                                <div className={"today-info"}>
                                    <p>最新智能研报日期：<span className={"blue"}>{this.state.todayDate}</span></p>
                                    <p>最近7天共有 <span className={"red"}>{this.state.todayTotal}</span> 只个股的智能研报</p>
                                </div>
                            </Col>
                        </Row>
                        <Spin spinning={this.state.loading}>
                            <Space size={32}>
                            <div>
                                <div className={"top-title"}>
                                    <RightCircleTwoTone twoToneColor="#ec4d3d" /> &nbsp; 最新智能研报
                                </div>
                                <Table key={"r1"}
                                       columns={columns2}
                                       dataSource={this.state.mainData.dayList}
                                       bordered
                                       rowKey="symbol"
                                       size="small"
                                       pagination={false}/>
                            </div>
                            <div>
                                <div className={"top-title"}>
                                    <RightCircleTwoTone twoToneColor="#ec4d3d" /> &nbsp; 近一周研报数量排行
                                </div>
                                <Table key={"r2"}
                                       columns={columns}
                                       dataSource={this.state.mainData.weekList}
                                       bordered
                                       rowKey="symbol"
                                       size="small"
                                       pagination={false}/>
                            </div>
                            <div>
                                <div className={"top-title"}>
                                    <RightCircleTwoTone twoToneColor="#ec4d3d" /> &nbsp; 近一月研报数量排行
                                </div>
                                <Table key={"r3"}
                                       columns={columns}
                                       dataSource={this.state.mainData.monthList}
                                       bordered
                                       rowKey="symbol"
                                       size="small"
                                       pagination={false}/>
                            </div>
                        </Space>
                        </Spin>
                    </div>
                </div>
                {/*<div id={"report"}>{this.state.mainData?.infoJson}</div>*/}
                <NavFooter/>
            </Layout>
        )
    }

    loadSymbolData = () => {
        const callback2 = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({
                    todayTotal: dat.count,
                    todayDate: dat.publish_date
                });
            }
        }               
        AxiosUtil.AxiosRequest('/api/ybTask/getTaskCount', {}  , callback2);
    }
    loadMainData = () => {
        this.setState({loading: true});
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({mainData: dat})
            }
            this.setState({loading: false});
        }
        AxiosUtil.AxiosRequest('/api/yb/getYbCountByDay', {}, callback);
    }
}
